<template>
    <div
        class="search-result"
        :class="{ isActive: id === activeId}"
        @click.prevent="$emit('click', resultUrl(data.customer_id, data.id))"
    >
        <div class="header">
            Contract #{{ data.id }}
        </div>
        <div class="subline">
            Product: {{ data.product_name }}
        </div>
        <div class="subline">
            Status: {{ data.status }} <span v-if="data.open_termination !== null">(termination pending)</span>
        </div>
        <div class="subline">
            Customer: {{ customerName }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'SearchResultContract',
    props: {
        data: {
            type: Object,
            default: () => {
                return null
            }
        },
        id: {
            type: Number,
            default: () => {
                return null
            }
        },
        activeId: {
            type: Number,
            default: () => {
                return null
            }
        }
    },
    emits: ['click'],
    computed: {
        customerName () {
            if (!this.data.customer.company) return `${this.data.customer.firstname} ${this.data.customer.lastname} #${this.data.customer_id}`

            return `${this.data.customer.firstname} ${this.data.customer.lastname} (${this.data.customer.company}) #${this.data.customer_id}`
        }
    },
    created () {
        window.addEventListener('keydown', this.handleKeys)
    },
    unmounted () {
        window.removeEventListener('keydown', this.handleKeys)
    },
    methods: {
        resultUrl (customerId, contractId) {
            return this.$route('customers.customers.contracts.index', {
                customer: customerId,
                contract: contractId
            })
        },
        handleKeys (event) {
            // ENTER
            if (event.code === 'Enter') {
                this.$emit('click', this.resultUrl(this.data.customer_id, this.data.id))
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.search-result {
    padding: 15px 25px;
    transition: 0.2s ease-in-out all;
    display: flex;
    flex-direction: column;
    grid-gap: 10px;
    text-decoration: none;

    &:hover {
        background: rgba(0,0,0,0.07);
        cursor: pointer;
    }

    & .header {
        font-weight: bold;
        font-size: 16px;
        color: #222;
        background: transparent;
    }
    & .subline {
        color: rgba(0,0,0,0.6);
    }
}
.isActive {
    background: rgba(0,0,0,0.07);
}
</style>
